module.exports = __webpack_public_path__ + "img/john-deere-logo.7c36b18d.jpg";